import EmptyCustomerIcon from './svg/empty/customer-supplier-empty.svg'

export default EmptyCustomerIcon
